export function shapeThumbnailSheetConfig(sheets: any) {
	return typeof sheets === 'string'
		? JSON.parse(sheets)
		: sheets || undefined;
}
